import { motion } from "framer-motion";
import { scoreColor } from "@/lib/format";

export default function StrengthGauge({ score = 50, size = 180, label = "Strength Score", testId = "strength-gauge" }) {
  const s = Math.max(0, Math.min(100, score || 0));
  const r = size / 2 - 14;
  const c = Math.PI * r;
  const color = scoreColor(s);
  const strong = s >= 75;
  const bias = s >= 65 ? "BULLISH" : s <= 35 ? "BEARISH" : "NEUTRAL";
  return (
    <div className="relative flex flex-col items-center" data-testid={testId}>
      {strong && <span aria-hidden className="absolute top-6 h-20 w-20 rounded-full rx-pulse-ring" style={{ background: `${color}33` }} />}
      <svg width={size} height={size / 2 + 16} viewBox={`0 0 ${size} ${size / 2 + 16}`}>
        <path d={`M14 ${size / 2} A ${r} ${r} 0 0 1 ${size - 14} ${size / 2}`} fill="none" stroke="rgba(255,255,255,0.07)" strokeWidth="12" strokeLinecap="round" />
        <motion.path d={`M14 ${size / 2} A ${r} ${r} 0 0 1 ${size - 14} ${size / 2}`} fill="none" stroke={color} strokeWidth="12" strokeLinecap="round"
          strokeDasharray={c} initial={{ strokeDashoffset: c }} animate={{ strokeDashoffset: c - (s / 100) * c }}
          transition={{ type: "spring", stiffness: 60, damping: 15 }} style={{ filter: strong ? `drop-shadow(0 0 8px ${color})` : "none" }} />
      </svg>
      <div className="-mt-12 text-center">
        <div className="font-data text-4xl font-bold" style={{ color }} data-testid={`${testId}-value`}>{s.toFixed(0)}</div>
        <div className="rx-label mt-1">{label}</div>
        <div className="font-data text-xs mt-1 font-bold tracking-widest" style={{ color }}>{bias}</div>
      </div>
    </div>
  );
}
